import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBellSlash } from '@fortawesome/free-solid-svg-icons';

import AlertsTableHeader from './AlertsTableHeader';
import DmAlertsTableHeader from './DmAlertsTableHeader';
import AlertsTableBody from './AlertsTableBody';
import DmAlertsTableBody from './DmAlertsTableBody';
import { Loading } from '../NoDataIndication';

function AlertAndDmTable(props) {
  const {
    assetView,
    data,
    dataLoading,
    handleRuleLinkClick,
    includeChildren,
    orgIdFilter,
    selectedStatus,
    tab,
    toggleClearAlertModalClick,
  } = props;

  const renderTableBody = useMemo(
    () => !dataLoading && data?.length,
    [data?.length, dataLoading]
  );

  return (
    <>
      <div className="d-none d-lg-block table-responsive-lg w-100 mx-lg-4">
        <table className="table">
          <thead>
            {
              {
                alerts: <AlertsTableHeader {...props} />,
                dm1: <DmAlertsTableHeader {...props} />,
              }[tab]
            }
          </thead>
          <tbody>
            {renderTableBody
              ? {
                  alerts: (
                    <AlertsTableBody
                      assetView={assetView}
                      data={data}
                      handleRuleLinkClick={handleRuleLinkClick}
                      includeChildren={includeChildren}
                      orgIdFilter={orgIdFilter}
                      selectedStatus={selectedStatus}
                      toggleClearAlertModalClick={toggleClearAlertModalClick}
                    />
                  ),
                  dm1: <DmAlertsTableBody assetView={assetView} data={data} />,
                }[tab]
              : null}
          </tbody>
        </table>
      </div>
      {(() => {
        switch (true) {
          case dataLoading:
            return (
              <div className="h-75 w-100 d-flex align-items-center justify-content-center">
                <Loading />
              </div>
            );
          case !data?.length:
            return (
              <div className="h-75 w-100 d-flex flex-column align-items-center justify-content-center">
                <FontAwesomeIcon
                  icon={faBellSlash}
                  className="text-brand-primary mb-3"
                  size="5x"
                />
                <h4 className="text-brand-primary">
                  No recent {tab === 'alerts' ? 'alerts' : 'DM1 faults'}!
                </h4>
              </div>
            );
          default:
            return null;
        }
      })()}
    </>
  );
}

AlertAndDmTable.propTypes = {
  asset: PropTypes.shape({
    _id: PropTypes.string,
    orgID: PropTypes.string,
  }),
  assetView: PropTypes.bool,
  children: PropTypes.bool,
  currentOrg: PropTypes.object,
  data: PropTypes.arrayOf(PropTypes.object),
  dataLoading: PropTypes.bool,
  handleAssetSelected: PropTypes.func,
  handleDmFilterSelected: PropTypes.func,
  handleOrgSelected: PropTypes.func,
  handleRuleLinkClick: PropTypes.func,
  handleRuleSelected: PropTypes.func,
  handleSortClick: PropTypes.func,
  handleStatusSelected: PropTypes.func,
  includeChildren: PropTypes.bool,
  orgIdFilter: PropTypes.string,
  selectedStatus: PropTypes.oneOf(['positive', 'negative', 'all']),
  setDmExport: PropTypes.func,
  sort: PropTypes.shape({
    by: PropTypes.oneOf(['TriggeredAt', 'DetectedAt']),
    direction: PropTypes.oneOf(['ASC', 'DESC']),
  }),
  tab: PropTypes.oneOf(['alerts', 'dm1']),
  toggleClearAlertModalClick: PropTypes.func,
};

export default memo(AlertAndDmTable);
